<h3 class="header">{{ 'SHARED.ORDERTRACKING.ORDERSUM' | translate }}</h3>
<div class="cw-horizontalline"></div>

<div class="footer" [formGroup]="orderFooterFormGroup" [class]="editMode ? '' : 'cw-order-price-summary'">
  <!-- Gesamtsumme (Menge) -->
  <phscw-input-number
    label="{{ 'SHARED.ORDERTRACKING.ARTICLESUM' | translate }}"
    formControlName="order_amount_total">
  </phscw-input-number>
  <!-- Gesamtsumme (kostenlose Menge) -->
  <phscw-input-number
    label="{{ 'SHARED.ORDERTRACKING.ARTICLESUMFREE' | translate }}"
    formControlName="order_amount_free_total">
  </phscw-input-number>
  <!-- Rabatt Text -->
  <phscw-input-text
    label="{{ 'SHARED.ORDERTRACKING.DISCOUNTTEXT' | translate }}"
    formControlName="order_discount_text"
    inputId="order_discount_text">
  </phscw-input-text>
  <!-- Zwischensumme (Artikel-Summe ohne Rabatt) -->
  <phscw-input-number
    label="{{ 'SHARED.ORDERTRACKING.INTERMEDIATETOTAL' | translate }}"
    formControlName="order_sum"
    [valueType]="'currency'"
    [customFormat]="customCurrencyFormat">
  </phscw-input-number>
  <!-- Versandkosten -->
  @if (orderFormService.orderAccessRightsExplicit['shipping_costs']['ngIf']) {
    <phscw-input-number
      [editMode]="orderFormService.orderAccessRightsExplicit['shipping_costs']['editMode'] && editMode"
      [required]="orderFormService.orderAccessRightsExplicit['shipping_costs']['required']"
      label="Versandkosten"
      formControlName="shipping_costs"
      [valueType]="'currency'"
      [customFormat]="customCurrencyFormat">
    </phscw-input-number>
  }
  <!-- Rechnungsrabatt total % -->
  <phscw-input-number
    label="Total Rabatt %"
    formControlName="order_discount_mean"
    [valueType]="'percent'"
    [maxValue]="100"
    [minValue]="0"
    [customFormat]="customCurrencyFormat">
  </phscw-input-number>
  <!-- Rechnungsrabatt total € -->
  <phscw-input-number
    label="Total Rabatt €"
    formControlName="order_discount_sum"
    [valueType]="'currency'"
    [customFormat]="customCurrencyFormat">
  </phscw-input-number>
  <!-- Gesamtsumme -->
  <phscw-input-number
    label="Gesamt netto"
    formControlName="order_total"
    [valueType]="'currency'"
    [customFormat]="customCurrencyFormat">
  </phscw-input-number>
</div>
